module.exports = {
      id: "default-card-image-usage",
      viewBox: "0 0 1024 683",
      url: "/" + "svg-sprite-475344759687326ca60b708b4aa20d33.svg#default-card-image",
      toString: function () {
        return this.url;
      }
    }